'use client';

import { type PropsWithChildren } from 'react';

import { useLockedResourcePrompt } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/components/locked-resource-prompt';
import { Link } from '@module/mdrt-org/shared/i18n';

export const LockedContentModalTriggerWrapper = ({
  children,
  className,
  cmsContent,
  'data-testid': dataTestId,
  resourceUrl,
}: PropsWithChildren<{
  className?: string;
  cmsContent: {
    cancelLabel: string;
    lockedResourceModalHeading: string;
    lockedResourceModalSubheading: string;
    loginLinkLabel: string;
  };
  ['data-testid']?: string;
  resourceUrl: string;
}>) => {
  const { onResourceClick, renderLockedResourcePrompt, shouldLockedResourcePromptBeShown } =
    useLockedResourcePrompt({
      cmsContent,
      isResourceLocked: true,
      resourceUrl,
    });

  const sharedProps = {
    className,
    'data-testid': dataTestId,
  };

  return (
    <>
      {renderLockedResourcePrompt()}
      {shouldLockedResourcePromptBeShown ? (
        <button {...sharedProps} onClick={onResourceClick} type="button">
          {children}
        </button>
      ) : (
        <Link {...sharedProps} href={resourceUrl} scroll>
          {children}
        </Link>
      )}
    </>
  );
};
